import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// interceptor to inject token based on route context
api.interceptors.request.use((config) => {
  const role = config.headers["X-Role"] || null;
  let token = null;
  if (role === "master") token = localStorage.getItem("master_token");
  else if (role === "frentista") token = localStorage.getItem("frentista_token");
  else {
    // auto: prefer frentista if on tablet flow, else master
    token = localStorage.getItem("frentista_token") || localStorage.getItem("master_token");
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  delete config.headers["X-Role"];
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // don't auto-redirect; caller handles
    }
    return Promise.reject(err);
  }
);

export default api;

export const masterApi = {
  get: (url, opts = {}) => api.get(url, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "master" } }),
  post: (url, data, opts = {}) => api.post(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "master" } }),
  put: (url, data, opts = {}) => api.put(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "master" } }),
  patch: (url, data, opts = {}) => api.patch(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "master" } }),
  delete: (url, opts = {}) => api.delete(url, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "master" } }),
};

export const frentistaApi = {
  get: (url, opts = {}) => api.get(url, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "frentista" } }),
  post: (url, data, opts = {}) => api.post(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "frentista" } }),
  put: (url, data, opts = {}) => api.put(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "frentista" } }),
  patch: (url, data, opts = {}) => api.patch(url, data, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "frentista" } }),
  delete: (url, opts = {}) => api.delete(url, { ...opts, headers: { ...(opts.headers || {}), "X-Role": "frentista" } }),
};

// Public API (no auth — used by /pesquisa public page)
const publicAxios = axios.create({ baseURL: API });
export const publicApi = {
  get: (url, opts = {}) => publicAxios.get(url, opts),
  post: (url, data, opts = {}) => publicAxios.post(url, data, opts),
};

// Fila offline (4.12): reenvio SEM o interceptor acima. O item leva o token do vendedor que fez a
// venda; o interceptor trocaria pelo token de quem está logado agora (troca de turno = 404).
export const replayApi = {
  request: (config) => publicAxios.request(config),
};

export function formatBRL(v) {
  const n = Number(v) || 0;
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatL(v) {
  const n = Number(v) || 0;
  return n.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " L";
}

export function formatPhone(v) {
  const d = (v || "").replace(/\D/g, "");
  if (d.length === 11) return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
  if (d.length === 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return v;
}

export function onlyDigits(v) {
  return (v || "").replace(/\D/g, "");
}

export const PRODUTOS_LABEL = {
  gasolina_comum: "Gasolina Comum",
  gasolina_aditivada: "Gasolina Aditivada",
  etanol: "Etanol",
  diesel_s10: "Diesel S10",
  diesel_s500: "Diesel S500",
  troca_oleo: "Troca de Óleo",
};

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}
